// src/services/settings/cache.service.js
import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}settings/cache/`;

export default {
  clear() {
    return axios.post(`${API_URL}clear`, {}, { headers: buildHeaders() });
  },
};
